import React, { CSSProperties } from 'react';
import styles from './body.module.css';

interface Props {
  children: React.ReactNode;
  style?: CSSProperties;
}

export const Body = ({ children, style }: Props) => {
  return (
    <div className={styles.container} style={style}>
      {children}
    </div>
  );
};
